import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import { Chart } from '@kaizenplatform/kaizen-chartjs';

export const startFetchingCoverageReport = () =>
  produce((draft: Draft<State>) => {
    draft.coverageReportChart.fetching = draft.coverageReportChart.fetching + 1;
  });

export const setCoverageReport = (coverageReportChart: Chart | Chart[]) =>
  produce((draft: Draft<State>) => {
    draft.coverageReportChart.data = coverageReportChart;
  });

export const finishFetchingCoverageReport = () =>
  produce((draft: Draft<State>) => {
    draft.coverageReportChart.fetching = draft.coverageReportChart.fetching - 1;
  });

export const disposeCoverageReport = () =>
  produce((draft: Draft<State>) => {
    draft.coverageReportChart.data = initialState.coverageReportChart.data;
    draft.coverageReportChart.fetching = initialState.coverageReportChart.fetching;
  });
